import { render } from "./Appreciations.vue?vue&type=template&id=2c9bfe33&scoped=true"
import script from "./Appreciations.vue?vue&type=script&lang=js"
export * from "./Appreciations.vue?vue&type=script&lang=js"

import "./Appreciations.vue?vue&type=style&index=0&id=2c9bfe33&scoped=true&lang=css"

import exportComponent from "/Users/arkane/Dev/Projects/Web/ecole-alpha.proj/ecole-alpha.2025-2026.web/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.28_vue@3.3.8_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c9bfe33"]])

export default __exports__